<template>
<div class="container" id="main">
  <div class="form-row">
    <div class="col-6">
      <div class="form-group">
        <router-link to="/keys/new" class="btn btn-primary">New API Key</router-link>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="col-6">
      <div class="form-group">
        <input type="search" v-model="search" placeholder="Search Key" class="form-control" @input="onSearch" />
      </div>
    </div>
    <div class="col-3">
      <div class="form-group">
        <v-select v-model="property" placeholder="Property" :options="properties" @input="onPropertyChange"></v-select>
      </div>
    </div>
    <div class="col-3">
      <div class="form-group">
        <v-select v-model="user" placeholder="User" :options="users" @input="onUserhange"></v-select>
      </div>
    </div>
  </div>

<table class="table table-light">
  <thead class="thead-dark">
    <tr>
      <th scope="col">Key</th>
      <th scope="col">Property</th>
      <th scope="col">User</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="row in rows" :key="row._id">
      <td style="max-width: 300px; overflow: hidden; text-overflow: ellipsis;"><router-link :to="'/keys/edit/' + row._id">{{row.key}}</router-link></td>
      <td>{{row.property.title}}</td>
      <td v-if="row.user">{{row.user.name}}</td>
      <td v-else>N/A</td>
    </tr>
  </tbody>
</table>
<div class="progress" style="margin: 20px 0;" v-show="pagination">
  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
</div>
</div>
</template>
<script>
import {api} from '../api.js';
import ui from '../ui.js';
import vSelect from 'vue-select';

export default {
  name: 'Keys',
  components: {
    vSelect
  },
  data: function() {
    return {
      rows: [],
      pagination: false,
      fetching: false,
      page: 1,
      total: 0,
      properties: [],
      property: null,
      users: [],
      user: null,
      search: ''
    }
  },
  mounted: function() {
    window.addEventListener('scroll', this.onScroll);
    this.fetch();
    this.fetchProperties();
    this.fetchUsers();
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: function() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        if (this.pagination && !this.fetching) {
          this.fetching = true;
          this.paginate();
        }
      }
    },
    paginate: function() {
      this.page++;
      this.fetch();
    },
    fetch: function() {
      api.get('/keys', {
        params: {
          limit: 50,
          page: this.page,
          populate: ['user', 'property'],
          property: this.property ? this.property.value : '',
          user: this.user ? this.user.value : '',
          search: this.search.trim()
        }
      }).then((response) => {
        response.data.docs.forEach((doc) => {
          this.rows.push(doc);
        });
        this.pagination = response.data.page < response.data.pages;
        this.fetching = false;
      }).catch((error) => {
        ui.alert(error.response.data);
        this.fetching = false;
      });
    },

    fetchProperties: function() {
      api.get('/properties', {
        params: {
          limit: 100
        }
      }).then((response) => {
        this.properties = [];
        response.data.docs.forEach((property) => {
          this.properties.push({
            label: property.title,
            value: property._id
          });
        });
      }).catch((error) => {
        ui.alert(error.response.data);
      });
    },

    fetchUsers: function() {
      api.get('/users', {
        params: {
          limit: 1000
        }
      }).then((response) => {
        this.users = [];
        response.data.docs.forEach((user) => {
          this.users.push({
            label: user.name,
            value: user._id
          });
        });
      }).catch((error) => {
        ui.alert(error.response.data);
      });
    },

    onPropertyChange: function() {
      this.rows = [];
      this.page = 1;
      this.fetch();
    },
    onUserhange: function() {
      this.rows = [];
      this.page = 1;
      this.fetch();
    },
    onSearch: function() {
      this.rows = [];
      this.page = 1;
      this.fetch();
    }
  }
}
</script>
